import React from "react";
import Slider from "react-slick";
import "./Testimonials.css"; // Fixed import path

const TESTIMONIALS_DATA = [
  {
    id: 1,
    text:
      "BMC Garam Masala is my go-to now. It's got that roasted-spice depth without the bitterness that ruins a lot of blends. Just a pinch at the end of cooking transforms my dal, paneer, or even bhindi into something richer. You can smell the difference.",
    name: "Priya Deshpande",
    age: 37,
    location: "Pune, Maharashtra",
    rating: 5,
  },
  {
    id: 2,
    text:
      "I've used a lot of spice blends over the years, but BMC Special Meat Masala stands out. The aroma alone tells you it's quality stuff. I use it for mutton curry, and people think I slow-roasted whole spices myself. It adds warmth without overdoing the heat.",
    name: "Samiulla Rehman",
    age: 44,
    location: "Hyderabad, Telangana",
    rating: 5,
  },
  {
    id: 3,
    text:
      "I picked up BMC Chana Masala on a trip to Mumbai, and it's now a regular in my kitchen. It gives chhole that real Delhi-style flavor — tangy, spicy, and bold without being harsh. Even my South Indian guests loved it with puris!",
    name: "Lalita Iyer",
    age: 58,
    location: "Kochi, Kerala",
    rating: 5,
  },
  {
    id: 4,
    text:
      "BMC Kitchen King Masala is a hidden gem. I sprinkle it into my mixed vegetables or paneer sabzi, and it just lifts the dish. It's got this rounded flavor — slightly sweet, slightly earthy — that makes simple meals taste restaurant-level.",
    name: "Ravi Shankar",
    age: 39,
    location: "Mysuru, Karnataka",
    rating: 5,
  },
  {
    id: 5,
    text:
      "Working with Bawa Masala Company for the last three years has helped us build a loyal customer base in our region. Their spice quality is consistent, and dispatch has never let us down.",
    name: "Rajesh Mehta",
    age: "Regional Distributor",
    location: "Jaipur",
    rating: 5,
  },
  {
    id: 6,
    text:
      "We've stocked BMC masalas for four years now. Customers ask for them by name, so restocking is quick, and the team is easy to reach if we ever need a rush order before a festival.",
    name: "Sunita Agarwal",
    age: "Wholesale Stockist",
    location: "Ludhiana",
    rating: 5,
  },
];

const StarRating = ({ rating = 5 }) => {
  return (
    <div className="testimonial__rating">
      {[1, 2, 3, 4, 5].map((_, index) => (
        <img key={index} src="/assets/staricon.png" alt="Star Rating" className="testimonial__star-icon" />
      ))}
    </div>
  );
};

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="testimonial__card">
      <div className="testimonial__content">
        <div className="testimonial__quote">
          <StarRating rating={testimonial.rating} />
          <hr></hr>
          <i className="fa fa-quote-left" aria-hidden="true" />
        </div>
        <p className="testimonial__text">{testimonial.text}</p>

        <div className="testimonial__author">
          <h4 className="testimonial__name">
            {testimonial.name}, {testimonial.age}
          </h4>
          <p className="testimonial__location">{testimonial.location}</p>
        </div>
      </div>
    </div>
  );
};

const TESTIMONIALS_SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  centerMode: false,
  variableWidth: false, // Remove any custom transform settings that might interfere with slider movement
  swipeToSlide: true,
  focusOnSelect: false,
  cssEase: "ease-out",
  pauseOnHover: true,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        centerPadding: "40px",
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        centerPadding: "20px",
        dots: true,
      },
    },
  ],
};

class Testimonials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderError: false,
    };
  }

  componentDidMount() {
    this.loadReviewWidget();
  }

  loadReviewWidget = () => {
    // Check if script is already loaded
    if (document.querySelector('script[src="https://grwapi.net/widget.min.js"]')) {
      return;
    }

    const script = document.createElement("script");
    script.src = "https://grwapi.net/widget.min.js";
    script.async = true;
    script.onload = () => {
      console.log("Review widget script loaded successfully");
    };
    script.onerror = () => {
      console.error("Failed to load review widget script");
    };
    document.head.appendChild(script);
  };

  handleSliderError = (error) => {
    console.error("Slider error:", error);
    this.setState({ sliderError: true });
  };

  renderGoogleReviews = () => (
    <div className="testimonials__google-reviews">
      <div className="reviews-container">
        <div className="google-reviews-badge">
          <div className="review-widget_net" data-uuid="9f739938-cf88-46b6-b7d9-9f2f0baa8d4e" data-template="10" data-lang="en" data-theme="light"></div>
        </div>
      </div>
    </div>
  );

  render() {
    const { sliderError } = this.state;

    if (sliderError) {
      // Fallback to grid layout if slider fails
      return (
        <section className="testimonials">
          <div className="testimonials__container">
            <div className="testimonials__header">
              <h2 className="global__heading">What Our Customers Say</h2>
              <p className="testimonials__subtitle">
                From home kitchens to regional distributors — BMC's quality and consistency earn trust across India.
              </p>
            </div>
            <div className="testimonials__grid">
              {TESTIMONIALS_DATA.map((testimonial) => (
                <TestimonialCard key={testimonial.id} testimonial={testimonial} />
              ))}
            </div>
            {this.renderGoogleReviews()}
          </div>
        </section>
      );
    }

    try {
      return (
        <section className="testimonials">
          <div className="testimonials__container">
            <div className="testimonials__header">
              <h2 className="global__heading">What Our Customers Say</h2>
              <p className="testimonials__subtitle">From home kitchens to regional distributors — BMC's quality and consistency earn trust across India.</p>
            </div>
            <div className="testimonials__slider">
              <Slider {...TESTIMONIALS_SLIDER_SETTINGS}>
                {TESTIMONIALS_DATA.map((testimonial) => (
                  <div key={testimonial.id} className="testimonials__slide">
                    <div className="testimonials__slide-inner">
                      <TestimonialCard testimonial={testimonial} />
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
            {this.renderGoogleReviews()}
          </div>
        </section>
      );
    } catch (error) {
      this.handleSliderError(error);
      return null;
    }
  }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/Testimonials/index.jsx